import { systemCode } from "../..";
import { parseOdds } from "./parseOdds";
import { specialIncreasedBets } from "./specialIncreasedBets";

export function parseBet(bet, agg, freeze = false) {
    const odds = parseOdds(bet.eas, bet.cs);
	let betDesc = bet.ds;
	if(bet.dss && bet.dss[systemCode]){
		betDesc = bet.dss[systemCode];
	}
    const parsedBet = {
        id: bet.cs,
        desc: betDesc,
        groupingDesc: bet.gd,
        ranking: bet.rnk,
        parametrica: bet.par,
        handicap: bet.h,
        tipoHandicap: bet.th,
        calculateHandicapDescription: bet.chd,
        handicapTableDesc: bet.dth,
        legabile : bet.leg,
        odds,
        forceAntepost: bet.fant,
        liveTimer: bet.tl,
        mainLine: bet.ml,
        hideHandicap: bet.sjo,
        handicapInfo: bet.ia,
        aggId: agg?.id ?? null,
        aggDesc: agg?.ds ?? null,
        extraOddsMarket : bet.sex,
        superOddsMarket : bet.sq,
        combinationType : bet.comt,
        miminumOddForOtherSelections : bet.comt? bet.qmo : 0,
        nativeOddsLength : bet.nef
    };

    if (parsedBet.extraOddsMarket) {
    	const key = `${parsedBet.id}_${parsedBet.handicap}`;
    	specialIncreasedBets.extraOdds[key] = parsedBet;
    } else if (parsedBet.superOddsMarket) {
    	const key = `${parsedBet.id}_${parsedBet.handicap}`;
    	specialIncreasedBets.extraOdds[key] = parsedBet;
    }

    if (freeze) {
        Object.freeze(parsedBet);
    }
    
    return parsedBet;
}
